// Einfacher E-Mail-Service - Cloud Function wird automatisch durch Firebase Trigger ausgelöst
export const sendNotificationEmail = async (formData, uploadedFiles) => {
  try {
    // Die Cloud Function wird automatisch ausgelöst, wenn Daten in Firebase gespeichert werden
    // Wir simulieren hier nur eine kurze Verzögerung und prüfen dann den Status
    
    console.log('E-Mail wird über Cloud Function gesendet...');
    
    // Kurze Verzögerung für die Cloud Function
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // In Realität würden wir hier den Status aus Firebase prüfen
    // Für jetzt nehmen wir an, dass es erfolgreich war
    return {
      success: true,
      messageId: `auto_${Date.now()}`,
      timestamp: new Date().toISOString()
    };
    
  } catch (error) {
    console.error('Fehler beim E-Mail-Service:', error);
    
    return {
      success: false,
      error: error.message || 'Unbekannter Fehler bei der E-Mail-Versendung'
    };
  }
};
